import {List} from "immutable";

// Hook to obtain with and height of an element
const useResizeSensorHandler = (entries) => {

    let elementSize;

    if (List.isList(entries)) {
        entries = entries.toJS();
    }

    if (entries && entries[0] && entries[0].contentRect) {

        elementSize = {
            width: entries[0].contentRect.width,
            height: entries[0].contentRect.height,
            clientWidth: entries[0].target.clientWidth,
            clientHeight: entries[0].target.clientHeight,
            scrollWidth: entries[0].target.scrollWidth,
            scrollHeight: entries[0].target.scrollHeight
        };

    }

    return elementSize;

};

export default useResizeSensorHandler;